import { createElement } from 'react'
import { ElementFactory, Serializer } from 'survey-core'
import { ReactQuestionFactory, SurveyQuestionElementBase } from 'survey-react-ui'
import { PriorityDisplay, CUSTOM_TYPE } from './PriorityDisplayModel'
import { PriorityDisplayContent } from './PriorityDisplayContent'

export function registerPriorityDisplay (): void {
  ElementFactory.Instance.registerElement(
    CUSTOM_TYPE,
    (name) => {
      return new PriorityDisplay(name)
    }
  )

  Serializer.addClass(
    CUSTOM_TYPE,
    [{
      name: 'priorityLevel',
      type: 'number',
      category: 'general',
      default: 1
    }],
    function () {
      return new PriorityDisplay('')
    },
    'question'
  )

  ReactQuestionFactory.Instance.registerQuestion(CUSTOM_TYPE, (props) => {
    return createElement(SurveyQuestionPriorityDisplay, props)
  })
}

export class SurveyQuestionPriorityDisplay extends SurveyQuestionElementBase {
  get question (): PriorityDisplay {
    return this.questionBase as PriorityDisplay
  }

  get priorityLevel (): number {
    return this.question.priorityLevel
  }

  renderElement (): JSX.Element {
    return <PriorityDisplayContent question={this.question} />
  }
}

export { PriorityDisplay } from './PriorityDisplayModel'
